<p-card styleClass="flex h-full p-4">
  <ng-template pTemplate="header">
    <h2>Miscellaneous Statistics</h2>
  </ng-template>
  <div class="stats-content h-full">
    <ul class="stats-list h-full flex flex-col">
      <!-- Active Partners Stats -->
      <li class="flex justify-between items-center stat-item flex-1">
        <div class="stat-info">
          <div class="stat-header">
            <span class="stat-title text-lg">Active Church Partners</span>
          </div>
          <div class="stat-description">
            <span class="stat-subtitle">Churches in Roots having received a team in the last year (or next 3 months)</span>
          </div>
        </div>
        <div class="stat-knob flex flex-col items-center gap-2">
          <p-knob 
            [(ngModel)]="activePartnersPercentage" 
            [readonly]="true"
            [size]="100"
            [strokeWidth]="10"
            [showValue]="true"
            [valueTemplate]="'{value}%'">
          </p-knob>
          <span class="stat-count">{{activePartners}} / {{totalPartners}}</span>
        </div>
      </li>

      <p-divider />

      <!-- Remaining Participants Stats -->
      <li class="flex justify-between items-center stat-item flex-1">
        <div class="stat-info">
          <div class="stat-header">
            <span class="stat-title text-lg">Remaining Participants <small>({{currentYear}})</small></span>
          </div>
          <div class="stat-description">
            <span class="stat-subtitle">{{remainingTrips}} of {{totalTrips}} teams remaining</span>
          </div>
        </div>
        <div class="stat-knob flex flex-col items-center gap-2">
          <p-knob 
            [(ngModel)]="remainingParticipantsPercentage" 
            [readonly]="true"
            [size]="100"
            [strokeWidth]="10"
            [showValue]="true"
            [valueTemplate]="'{value}%'">
          </p-knob>
          <span class="stat-count">{{remainingParticipants}} / {{totalParticipants}}</span>
        </div>
      </li>
    </ul>
  </div>
</p-card> 